module.exports = __webpack_public_path__ + "static/media/banner-phone@2x.636eff87.png";